// What the share modal is sharing. One modal (ShareModal) serves a list and a single athlete; a subject
// carries everything that differs: endpoints, the link, the channel sub-lines and the preview copy.
// The preview copy must match what the backend sends (report_share.list_share_lines,
// athlete_share.athlete_lines) — the sender sees exactly what the coach receives. On the Text channel the
// preview is the whole SMS body (report_share.send_report_sms, athlete_share.send_sms), one line.
import React from 'react';
import { shortLink } from '../lists/ListHeader';

const bare = (url) => String(url || '').replace(/^https?:\/\//, '');
const smsBody = (line1, link) => `ProZpects: ${line1} — ${link}. Msg & data rates may apply. Reply STOP to opt out.`;

export function listSubject({ id, code, title, sport, count }) {
  const link = shortLink(code);
  const n = Number(count) || 0;
  return {
    title: `Share "${title}"`,
    sendPath: `/reports/${id}/share`,
    historyPath: `/reports/${id}/recipients`,
    link,
    subLines: { email: 'Link + code to an inbox', text: 'Link + code by SMS', link: 'Paste it anywhere' },
    previewLines: (senderFirst, channel) => (channel === 'text' ? [smsBody(
      `${senderFirst || 'ProZpects'} shared a list with you: ${title}`, link)] : [
      `${senderFirst || 'ProZpects'} shared a list with you: ${title}`,
      <>
        {`${n} ${sport} athlete${n === 1 ? '' : 's'} · open it at `}
        <strong className="ls-share__preview-link">{bare(link)}</strong>
        {' or enter code '}
        <code className="ls-share__preview-code">{code}</code>
        {' in ProZpects.'}
      </>,
    ]),
  };
}

export function athleteSubject({ userId, name, position, graduationYear, highSchool, state, publicUrl }) {
  const school = [highSchool, state].filter(Boolean).join(', ');
  const facts = [position, graduationYear ? `Class of ${graduationYear}` : '', school].filter(Boolean).join(' · ');
  return {
    title: `Share ${name}`,
    sendPath: `/athletes/${userId}/share`,
    historyPath: `/athletes/${userId}/share-recipients`,
    link: publicUrl,
    subLines: { email: 'Profile link to an inbox', text: 'Profile link by SMS', link: 'Paste it anywhere' },
    previewLines: (senderFirst, channel) => (channel === 'text' ? [smsBody(
      `${senderFirst || 'ProZpects'} shared an athlete with you: ${name}`, publicUrl)] : [
      `${senderFirst || 'ProZpects'} shared an athlete with you: ${name}`,
      <>
        {facts && <span className="ls-share__preview-row">{facts}</span>}
        <span className="ls-share__preview-row">
          {'View the profile at '}
          <strong className="ls-share__preview-link">{publicUrl}</strong>
        </span>
      </>,
    ]),
  };
}
